import { Option } from "../Select";

export type Options = Option[] | string[];

export function isStringArray(options: Options): options is string[] {
  return options.length > 0 && typeof options[0] === "string";
}

export const toOptionArray = (array: Option[] | string[]) =>
  isStringArray(array) ? array.toLabelValue() : array;

export function toNumberFormat(value?: string | number): string | number {
  if (!value) {
    return value;
  }

  return value
    .toString()
    .replace(/,/g, ".")
    .replace(/[^0-9.]/g, "")
    .replace(/\./g, (match, offset, string) => {
      return string.indexOf(".") === offset ? match : "";
    });
}

export function formatDotsToCommas(value?: string | number): string | number {
  if (!value) {
    return value;
  }

  return value.toString().replace(/\./g, ",");
}
